import { Component, OnInit, Input, Output } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { EmailService } from '../../../services/emails/email.service';
import { NotyService } from '../../../services/common/noty.service';
import { MatterStoreService } from '../../../services/matters/matter-store.service';
import { Matter } from '../../../models/matter';

@Component({
  selector: 'app-email-new',
  templateUrl: './email-new.component.html',
  styleUrls: ['./email-new.component.scss'],
})
export class EmailNewComponent implements OnInit {
  @Input() noRedirection: boolean = false;

  formSubmitting: boolean = false;
  loading: boolean = true;
  emailSub: string = '';
  emailBod: string = '';
  users: Array<any> = [];
  selectedBccUser: any;
  selectedCcUser: any;
  selectedToUser: any;
  selectedUsersIds: Array<any> = [];
  toUsers: Array<any> = [];
  ccUsers: Array<any> = [];
  bccUsers: Array<any> = [];
  to: Array<any> = [];
  cc: Array<any> = [];
  bcc: Array<any> = [];
  matterId: Number;

  constructor(private emailService: EmailService, private route: ActivatedRoute, private router: Router, private notyService: NotyService, private matterStoreService: MatterStoreService) {
    //this.route.queryParams.subscribe(params=>{this.matterId = params.matter_id})
  }

  ngOnInit(): void {
    this.reset();
  }

  cancelEmailShare() {
    this.router.navigate([`/matters/${this.matterId}`]);
  }

  copyObject(obj: any): any {
    return Object.assign({}, obj);
  }

  fetchSelectedToUsers = () => {
    this.to = this.toUsers.filter(this.userChecked);
  };

  fetchSelectedCcUsers = () => {
    this.cc = this.ccUsers.filter(this.userChecked);
  };

  fetchSelectedBccUsers = () => {
    this.bcc = this.bccUsers.filter(this.userChecked);
  };

  makeEmailShare = () => {
    this.formSubmitting = true;
    console.log("make email share params", "to", this.to, "cc", this.cc, "bcc", this.bcc);
    this.emailService
      .create({
        matter_id: this.matterId,
        body: this.emailBod,
        subject: this.emailSub,
        to: this.to,
        cc: this.cc,
        bcc: this.bcc
      })
      .then((response_json) => {
        console.log('makeEmailShare response', response_json);
        if (response_json.success) {
          this.notyService.notify('Email Share Successful', 'success');
          this.formSubmitting = false;
          this.matterStoreService.matterAdministrationComponent!.reindexSolr('histories');
          if (!this.noRedirection) {
            this.router.navigate([`/matters/${this.matterId}`]);
          } else this.reset();
        } else {
          this.formSubmitting = false;
          this.notyService.notify(response_json.text, 'error');
        }
      })
      .catch((response_json) => {
        this.notyService.notify('Unkown Error', 'error');
        console.log('makeEmailShare error', response_json);
      });
  };

  reset = () => {
    this.matterId = Number(this.route.snapshot.params['matter_id'] || this.route.snapshot.params['id']);
    this.loading = true;
    this.formSubmitting = false;
    this.emailSub = '';
    this.emailBod = '';
    this.emailService
      .index({ form_options: true, matter_id: this.matterId })
      .then((response_json) => {
        const formatted_response_json = []
        for(let user_email of response_json.user_emails){
          user_email.label = user_email.name
          user_email.value = user_email.email
          let {name, email, ...new_user_email} = user_email
          formatted_response_json.push(new_user_email)
        }
        console.log("formatted_respons_json", formatted_response_json);
        this.loading = false;
        this.toUsers = formatted_response_json.map(this.copyObject);
        this.ccUsers = formatted_response_json.map(this.copyObject);
        this.bccUsers = formatted_response_json.map(this.copyObject);
        this.to = [];
        this.cc = [];
        this.bcc = [];
        console.log('emailService success', response_json);
      })
      .catch((er) => {
        console.log('emailService failure', er);
      });
  };

  userChecked(user: { isChecked: boolean }): boolean {
    return user.isChecked;
  }

  userEmail(user: { email: string }): string {
    return user.email;
  }
}
